/** A new record id: a UUID v4, never one made by the database. */
export const newId = (): string => crypto.randomUUID();
